export default function MessengerIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill="none"
            aria-hidden="true"
            viewBox="0 0 24 24"
        >
            <path
                fill="#08F"
                d="M12 3c-4.92 0-8.91 3.729-8.91 8.332 0 2.616 1.29 4.952 3.31 6.479V21l3.042-1.687c.81.228 1.668.35 2.559.35 4.92 0 8.91-3.73 8.91-8.331C20.91 6.729 16.92 3 12 3zm.938 11.172l-2.305-2.394-4.438 2.454 4.865-5.163 2.305 2.395 4.439-2.455-4.866 5.163z"
            ></path>
        </svg>
    );
}